module.exports = __webpack_public_path__ + "img/5.96811e6d.png";